import React, { useEffect, useState } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import "../../css/Tab.css";
import { PRIVACYPOLICY, TERMSOFUSE } from "../../../services/UserRoutePath";

import { useLocation, useNavigate, useParams } from "react-router";

const PrivacyPolicy = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <Container className="my-5">
        <Row>
          <Col>
            <h1 className="mb-4">Privacy Policy</h1>
            <p>
              This Privacy Policy describes how Bridgeline Billing
              (“Bridgeline,”) collects, uses, and shares personal information of
              users who visit this website (the “Website”) or otherwise engage
              us by submitting a claim to us. This Privacy Policy does not apply
              to Bridgeline’s collection of information by any other means,
              including without limitation from its clients in the course of
              representing them.
            </p>
            <p>
              The then-current version of this Privacy Policy will apply each
              time you use the Website. Periodic review of this Privacy Policy
              is recommended as changes may apply. IF AT ANY TIME YOU DO NOT
              AGREE WITH THIS PRIVACY POLICY, YOU MUST IMMEDIATELY LEAVE THE
              WEBSITE. Any revised Privacy Policy will apply only to information
              collected after the date of the revised Privacy Policy.
            </p>
            <h2 className="mt-4">
              SECTION 1: THE MEANS IN WHICH WE COLLECT INFORMATION
            </h2>
            <p>
              Bridgeline collects information through the Website that you
              voluntarily provide to us, such as your name, email address, phone
              number, address, and any information that you submit with an
              online claim submission form. Your information may include your
              email address or transactional information, and categories of
              information, such as your phone number, and characteristics of
              protected classifications under state or federal law. Although you
              need not provide Bridgeline with personal information as a
              condition of using the Website, your failure to provide certain
              personal information when asked may prevent certain features of
              the Website from functioning and may prevent Bridgeline from
              effectively responding to your requests.
            </p>
            <p>
              Bridgeline uses cookies and other technologies that automatically
              collect technical information when you visit the Website. This
              information may include internet or other electronic network
              activity information and location data. The purpose of the use of
              cookies is to identify you as a unique user of a website by
              gathering information that web browsers and devices automatically
              make available, such as the user’s Internet Protocol (“IP”)
              address, internet service provider (“ISP”) domain name, computer
              and web browser type, pages visited on the Website, and other
              activity on the Website.{" "}
            </p>
            <h2 className="mt-4">
              SECTION 2: HOW WE USE AND DISCLOSE THE INFORMATION PROVIDED
            </h2>
            <p>
              Bridgeline uses the personal information you provide to respond to
              your inquiries. We may also use your information for business
              purposes, such as to operate and improve the Website, to comply
              with legal requirements, to maintain the security of the Website,
              and as otherwise disclosed to you at the time your information is
              collected. Further, we may use your information for commercial
              purposes, such as to send you marketing communications. You can
              unsubscribe from marketing emails at any time by clicking the
              unsubscribe link within the email or contacting us as outlined
              below. In other words, your information is processed for purposes
              of responding to you and communicating with you as per your
              consent based on legitimate needs. Bridgeline may disclose your
              personal information to third parties who assist Bridgeline in
              performing its functions, such as service providers. Bridgeline
              may also disclose your personal information under the following
              circumstances: (i) when required to do so by law; (ii) in response
              to a subpoena, court order, or other valid process; (iii) to
              protect against security incidents, fraud, or illegal activity;
              (iv) to debug, operate, and improve the Website; (v) when
              Bridgeline believes in its sole discretion that disclosure is
              necessary to protect the property or rights of Bridgeline, third
              parties, or the public at large; (vi) as otherwise requested or
              consented to by you. Bridgeline may further share aggregate
              information that does not personally identify you. Bridgeline does
              not disclose your personally identifying information, such as your
              name and email address, to unaffiliated third parties for direct
              marketing without your express consent.
            </p>

            <h2 className="mt-4">SECTION 3: OWNERSHIP TRANSFERS</h2>
            <p>
              Bridgeline reserves the right to transfer your personal
              information to a successor organization in the event of a merger,
              acquisition, or other sale of all or a portion of Bridgeline’s
              assets. Disclosure of all transferred personal information will be
              subject to this Privacy Policy, or to a new privacy policy if you
              are given notice of that new privacy policy and an opportunity to
              affirmatively opt out of it.{" "}
            </p>

            <h2 className="mt-4">SECTION 4: THIRD-PARTY WEBSITES</h2>
            <p>
              The Website contains links to third-party websites and platforms,
              including social media pages. This Privacy Policy does not apply
              to any information collected, used, or shared by third parties,
              and Bridgeline does not control and is not responsible for third
              parties. Before visiting or providing personal information to any
              third party, you should review its separate terms and privacy
              policy.
            </p>
            <h2 className="mt-4">
              SECTION 5: SHARED WEBSITE COMMUNICATIONS MADE TO THIRD PARTIES{" "}
            </h2>
            <p>
              The Website may contain the “share” this page or article feature
              to allow you to share information about Bridgeline through social
              media accounts or by sending an email on your behalf to the
              indicated recipient with links to certain Website pages. If you
              choose to share content through social media, you will be
              redirected to the third-party social media platform. Bridgeline
              does not retain, share, or store any recipient email address
              provided in connection with this type of feature. You acknowledge
              and agree that any communications sent by you to third parties by
              means of the Website are not private, and such communications may
              be read by third parties with or without your knowledge.
              Bridgeline reserves the right to use such communication for any
              purpose subject to this Privacy Policy.
            </p>
            <h2 className="mt-4">
              SECTION 6: SECURITY AND RETENTION OF PERSONAL INFORMATION
            </h2>
            <p>
              Bridgeline maintains reasonable security procedures and practices
              to protect against the unauthorized access, use, and disclosure of
              your personal information. However, no system can be secure, and
              your security also depends on you. Bridgeline will retain your
              information for the length of time necessary to fulfill the
              purposes outlined herein, unless a longer retention period is
              required or permitted by law or order. Information provided
              through the Website is processed and secured by web servers and
              systems in the United States.
            </p>
            <h2 className="mt-4">SECTION 7: PRIVACY RIGHTS</h2>
            <p>
              Under certain privacy laws, if they apply to you, you have the
              right to access, correct, obtain, and delete your personal
              information, and the right to opt-out of, object to, and withdraw
              consent for certain privacy practices and to not receive
              discriminatory treatment for the exercise of your privacy rights.
              To make any privacy request on behalf of yourself please contact
              us as outlined below with your name and email address. We may
              verify your request with information that Bridgeline maintains
              about you. Bridgeline does not sell your personal information. If
              you would like to make any request to access, delete, modify, or
              restrict processing of your personal information, please contact
              us as outlined below.
            </p>
            <h2 className="mt-4">Contact Information</h2>

            <p>
              We can be reached at{" "}
              <a href="mailto:office@bridgelinebilling.com">
                office@bridgelinebilling.com
              </a>
            </p>
            <p>
              <strong>Date:</strong> January 2025
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
